<template>
    <address-list scope="locations"></address-list>
</template>

<script>
import AddressList from '@/components/address/List.vue';

export default {
    name: 'LocationsList',

    components: {
        AddressList,
    },
};
</script>
